if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        
        // Handle different media types
        let activeMediaTemplate = null;
        let activeMediaContent = null;
        
        if (activeMedia) {
          // Check if it's a deferred media (3D models, videos with templates)
          if (activeMedia.nodeName === 'DEFERRED-MEDIA' || activeMedia.querySelector('template')) {
            activeMediaTemplate = activeMedia.querySelector('template');
            activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          }
          
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          if (container && activeMedia.width) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }

          // Load content for deferred media with YouTube videos
          if (
            activeMedia.nodeName === 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        }
      }
    }
  );
}
